import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import { cn } from "@client/utils/cn";

export const Page = withErrorBoundary(
  ({
    className,
    title,
    description,
    cta,
    children,
  }: {
    className?: string;
    title?: string;
    description?: string;
    cta?: React.ReactNode;
    children?: React.ReactNode;
  }) => (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <div className="relative flex-1 mx-auto w-full max-w-4xl p-4 py-12 md:px-8 md:py-24 flex flex-col gap-4 md:gap-6 overflow-x-hidden">
        {(title || cta) && (
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
            <div>
              <h1 className="text-2xl font-bold">{title}</h1>
              {description && (
                <p className="text-xs text-muted-foreground">{description}</p>
              )}
            </div>
            {cta}
          </div>
        )}
        <div className={cn("flex-1", className)}>{children}</div>
      </div>
    </div>
  ),
);
